import {
  INSTITUTION_START,
  INSTITUTION_DATA,
  INSTITUTION_END,
} from '../type';
import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

type Dispatch = (action: Action) => void;

const API_URL = process.env.REACT_APP_API_URL;

export const getAllInstitutions = () => async (dispatch: Dispatch): Promise<void> => {
  if (!validateToken()) { redirectToLogin(); return; }
  try {
    dispatch({ type: INSTITUTION_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/institution-master`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    const res = await response.json();
    if (response.ok) {
      const normalized = Array.isArray(res) ? res
        : Array.isArray(res?.content) ? res.content
        : Array.isArray(res?.data) ? res.data
        : Array.isArray(res?.data?.content) ? res.data.content
        : [];
      dispatch({ type: INSTITUTION_DATA, payload: normalized, loading: false });
    } else {
      dispatch({ type: INSTITUTION_END, payload: [{ res }], loading: false });
    }
  } catch (error) {
    dispatch({ type: INSTITUTION_END, payload: false, loading: false });
    console.error(error);
  }
};

export const createInstitution = (data: any): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    dispatch({ type: INSTITUTION_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/institution-master`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        institutionName: data.institutionName,
        contactNo: data.contactNo,
        emailAddress: data.emailAddress,
        status: data.status,
      }),
    });
    const res = await response.json();
    dispatch({ type: INSTITUTION_END, loading: false });
    if (response.ok) return { success: true, message: res.message || 'Created successfully' };
    return { success: false, message: res.message || 'Failed to create' };
  } catch (error: any) {
    dispatch({ type: INSTITUTION_END, loading: false });
    return { success: false, message: error.message };
  }
};

export const updateInstitution = (id: number, data: any): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    dispatch({ type: INSTITUTION_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/institution-master/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        institutionName: data.institutionName,
        contactNo: data.contactNo,
        emailAddress: data.emailAddress,
        status: data.status,
      }),
    });
    const res = await response.json();
    dispatch({ type: INSTITUTION_END, loading: false });
    if (response.ok) return { success: true, message: res.message || 'Updated successfully' };
    return { success: false, message: res.message || 'Failed to update' };
  } catch (error: any) {
    dispatch({ type: INSTITUTION_END, loading: false });
    return { success: false, message: error.message };
  }
};

export const getInstitutionById = (id: number): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    dispatch({ type: INSTITUTION_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/institution-master/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    const res = await response.json();
    dispatch({ type: INSTITUTION_END, loading: false });
    if (response.ok) return { success: true, data: res.data ?? res };
    return { success: false, message: res.message || 'Failed to fetch' };
  } catch (error: any) {
    dispatch({ type: INSTITUTION_END, loading: false });
    return { success: false, message: error.message };
  }
};

export const deleteInstitution = (id: number): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return { success: false }; }
  try {
    dispatch({ type: INSTITUTION_START, loading: true });
    const token = localStorage.getItem('loginToken');
    if (!token) throw new Error('Authorization token not found');

    const response = await fetch(`${API_URL}/api/institution-master/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    dispatch({ type: INSTITUTION_END, loading: false });
    if (response.ok) return { success: true, message: 'Deleted successfully' };
    const res = await response.json();
    return { success: false, message: res.message || 'Failed to delete' };
  } catch (error: any) {
    dispatch({ type: INSTITUTION_END, loading: false });
    return { success: false, message: error.message };
  }
};
